import { useEffect, useState } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type InviteContext = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SidebarChannel = any;

/**
 * Centralized state management for all sidebar dialogs and their context.
 * Manages:
 * - Workspace creation, editing, members, settings
 * - Channel creation, editing, deletion
 * - DM and browse channels
 * - Invite context
 * - Client space management
 */
export function useSidebarUIModalStates() {
  const [showCreateWorkspace, setShowCreateWorkspace] = useState(false);
  const [createChannelContext, setCreateChannelContext] = useState<
    | { spaceId: string; spaceName: string; hostWorkspaceId?: string }
    | "workspace"
    | null
  >(null);
  const [showEditChannel, setShowEditChannel] = useState(false);
  const [showDeleteChannel, setShowDeleteChannel] = useState(false);
  const [showBrowseChannels, setShowBrowseChannels] = useState(false);
  const [showWorkspaceSettings, setShowWorkspaceSettings] = useState(false);
  const [showCreateClientSpace, setShowCreateClientSpace] = useState(false);
  const [selectedClientSpace, setSelectedClientSpace] = useState<string | null>(
    null,
  );
  const [inviteContext, setInviteContext] = useState<InviteContext | null>(
    null,
  );
  const [contextChannel, setContextChannel] = useState<SidebarChannel | null>(
    null,
  );

  // Open the workspace invite dialog from anywhere (e.g. the Inbox onboarding
  // "Invite your team" card) via a window event carrying the workspace.
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as
        | { workspaceId?: string; workspaceName?: string }
        | undefined;
      if (!detail?.workspaceId) return;
      setInviteContext({
        type: "workspace",
        workspaceId: detail.workspaceId,
        workspaceName: detail.workspaceName ?? "",
      });
    };
    window.addEventListener("ano:open-workspace-invite", handler);
    return () =>
      window.removeEventListener("ano:open-workspace-invite", handler);
  }, []);

  return {
    // Workspace dialogs
    showCreateWorkspace,
    setShowCreateWorkspace,
    showWorkspaceSettings,
    setShowWorkspaceSettings,

    // Channel dialogs
    showEditChannel,
    setShowEditChannel,
    showDeleteChannel,
    setShowDeleteChannel,
    showBrowseChannels,
    setShowBrowseChannels,
    createChannelContext,
    setCreateChannelContext,
    contextChannel,
    setContextChannel,

    // Client space
    showCreateClientSpace,
    setShowCreateClientSpace,
    selectedClientSpace,
    setSelectedClientSpace,

    // Invite context
    inviteContext,
    setInviteContext,
  };
}
